import { Web3WalletContainer } from "module/wallet/container/Web3WalletContainer"

import { Button, Spacer, Stack, Text } from "@chakra-ui/react"
import { MarketStatus } from "@perp/sdk-curie"
import { AddDrop } from "component/Icon"
import { ModalType } from "component/Modal/type"
import { useModal } from "container/modal"
import { useMarket } from "sdk-react/markets/useMarket"

export interface Props {
    baseSymbol: string
    tickerSymbol: string
    addedLiquidityPositionCount: number
}

const maxLiquidityPositionCount = 3

export function LiquidityListHeader({ baseSymbol, tickerSymbol, addedLiquidityPositionCount }: Props) {
    const { account } = Web3WalletContainer.useContainer()
    const { open: openModalAddLiquidity } = useModal(ModalType.LIQUIDITY_ADD)

    let { status: marketStatus } = useMarket(tickerSymbol)
    const isMarketDisabled = marketStatus !== MarketStatus.ACTIVE
    const isLimitReached = addedLiquidityPositionCount >= maxLiquidityPositionCount
    const isAddDisabled = isMarketDisabled || isLimitReached

    return (
        <Stack spacing={4} direction={{ base: "column", md: "row" }} pb={1}>
            <Text fontSize="md" fontWeight="semibold">
                Liquidity Positions{" "}
                <Text as="span" opacity={0.5}>
                    ({addedLiquidityPositionCount}/{maxLiquidityPositionCount})
                </Text>
            </Text>
            <Spacer />

            {account && (
                <Button
                    isDisabled={isAddDisabled}
                    onClick={() => openModalAddLiquidity({ baseSymbol, tickerSymbol })}
                    colorScheme="purple"
                    size="sm"
                    leftIcon={<AddDrop boxSize="20px" />}
                >
                    {isLimitReached ? "Max Reached" : "Add Liquidity"}
                </Button>
            )}
        </Stack>
    )
}
